<template>
  <b-modal id="createUserDataAddressModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.userdataaddress.createUserDataAddressHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <UserDataAddressCreate :userDataIRI="userDataIRI"></UserDataAddressCreate>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import UserDataAddressCreate from '../Create.vue'
export default {
  name: 'CreateUserDataAddressModal',
  components: {
    UserDataAddressCreate
  },
  computed: {
    show () {
      return this.$store.state.modals.userdataaddress.create.show
    },
    computedUserDataIRI () {
      return this.$store.state.modals.userdataaddress.create.userDataIRI
    },
    close () {
      return this.$store.state.modals.userdataaddress.create.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      userDataIRI: null
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.computedUserDataIRI) {
        this.userDataIRI = this.$store.state.modals.userdataaddress.create.userDataIRI
        this.$store.state.modals.userdataaddress.create.show = 0
        this.$store.state.modals.userdataaddress.create.userDataIRI = null
        this.$bvModal.show('createUserDataAddressModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.userdataaddress.create.close = 0
        this.$bvModal.hide('createUserDataAddressModal')
      }
    },
    resetData () {
      // console.log()
    }
  }
}
</script>
